import {useTheme} from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Paper} from "@mui/material";
import React from "react";
import ValidatedTextField from "../Inputs/ValidatedTextField";
import {alphaNumericEmptyValidator, alphaNumericValidator, postcodeValidator} from "../../Helpers/ValidationHelpers";
import CountrySelect from "../Inputs/CountrySelect";

const ClientAddressView = ({
                               client,
                               edit,
                               setActiveForm,
                               isSubmitting,
                               formValid
                           }) => {
    const theme = useTheme();
    
    const fields = [
        {
            id: "addressLine1",
            label: "Line 1",
            value: client.addressLine1,
            validator: alphaNumericValidator,
            onChange: isValid => (formValid.current.addressLine1 = isValid),
            initialValue: client.addressLine1,
            fieldPath: ['addressLine1'],
            infoAdornment: null,
            size: "small",
            removeHelperTextPadding: true
        },
        {
            id: "addressLine2",
            label: "Line 2",
            value: client.addressLine2,
            validator: alphaNumericEmptyValidator,
            onChange: isValid => (formValid.current.addressLine2 = isValid),
            initialValue: client.addressLine2,
            fieldPath: ['addressLine2'],
            infoAdornment: null,
            size: "small",
            removeHelperTextPadding: true
        },
        {
            id: "addressCity",
            label: "City",
            value: client.addressCity,
            validator: alphaNumericEmptyValidator,
            onChange: isValid => (formValid.current.addressCity = isValid),
            initialValue: client.addressCity,
            fieldPath: ['addressCity'],
            infoAdornment: null,
            size: "small",
            removeHelperTextPadding: true
        },
        {
            id: "addressState",
            label: "State",
            value: client.addressState,
            validator: alphaNumericEmptyValidator,
            onChange: isValid => (formValid.current.addressState = isValid),
            initialValue: client.addressState,
            fieldPath: ['addressState'],
            infoAdornment: null,
            size: "small",
            removeHelperTextPadding: true
        },
        {
            id: "addressPostcode",
            label: "Postcode",
            value: client.addressPostcode,
            validator: postcodeValidator,
            onChange: isValid => (formValid.current.addressPostcode = isValid),
            initialValue: client.addressPostcode,
            fieldPath: ['addressPostcode'],
            infoAdornment: null,
            size: "small",
            removeHelperTextPadding: true
        }
    ]
    
    return (
        <Paper className="paper-rounded-edges">
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" className="detail-header-banner">Address</Typography>
                </Grid>
                {fields.map((field, index) => (
                    <Grid size={{ xs: 12}} key={index}>
                        <Box
                            sx={{
                                display:'flex',
                                justifyContent: 'space-between',
                                padding: '10px',
                                alignItems: 'center',
                                borderBottom: `1px solid ${theme.palette.divider}`
                            }}
                        >
                            <Typography sx={{ fontWeight: 'bold'}}>{field.label}</Typography>
                            {!edit &&
                                <Typography>{field.value}</Typography>
                            }
                            {edit &&
                                <ValidatedTextField
                                    id={field.id}
                                    label={null}
                                    validator={field.validator}
                                    onChange={field.onChange}
                                    setActiveForm={setActiveForm}
                                    isSubmitting={isSubmitting}
                                    initialValue={field.initialValue}
                                    fieldPath={field.fieldPath}
                                    infoAdornment={field.infoAdornment}
                                    size={field.size}
                                    removeHelperTextPadding={field.removeHelperTextPadding}
                                />
                            }
                        </Box>
                    </Grid>
                ))}
                <Grid size={{ xs: 12}}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            padding: '10px',
                            alignItems: 'center',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold'}}>Country</Typography>
                        {!edit &&
                            <Typography>{client.addressCountry}</Typography>
                        }
                        {edit &&
                            <CountrySelect
                                setActiveForm={setActiveForm}
                                onChange={isValid => (formValid.current.addressCountry = isValid)}
                                initialValue={client.addressCountry}
                                size={"small"}/>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default ClientAddressView;